import React, {useState} from 'react'
import { Formik, ErrorMessage, Field } from 'formik'
import { LoginContainer,DataContainer,InputContainer, ErrorStyled, VersionTag } from "./loginStyles"
//import { useNavigate } from 'react-router-dom'
import ButtonForm from '../../components/buttonForm/ButtonForm';
import { initialValuesLogin } from '../../formik/initialValues'
import { validationLogin } from '../../formik/validationSchema'
import { loginUser } from '../../axios/axiosUser';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCurrentUser } from '../../redux/user/userSlice';
import Spinner from '../../components/spinner/Spinner';
import Modal from '../../components/modal/Modal';
import { registrarLogin, registrarLoginFallido } from '../../registro/registro';

const Login = () => {
  const [error, setError] = useState(null);
  //const currentUser = useSelector((state)=>state.user.currentUser);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  return (
    <>
      <Formik 
        initialValues={initialValuesLogin}
        validationSchema={validationLogin}
        onSubmit={ async (values, {resetForm,setSubmitting}) => {
          setSubmitting(true);
          try{
                const user = await loginUser(values.username, values.password)
                //Cambie en la validacion del if, antes estaba solo USER
                if(user?.status?.success){
                        dispatch(
                          setCurrentUser({
                            ...user,
                            //Aca guardo mas datos como expiresAt y metadata para el deslogueo cuando se caiga el token
                            token: user.data.token,
                            expiresAt: user.data.expiresAt,
                            usuario: user.data.metadata.promotorNombre,
                            metadata: user.data.metadata
                          })
                        );
                        // Registro en el backend (no bloquea el ingreso).
                        registrarLogin();
                        resetForm();
                        navigate("/dashboard");
                      }   
                      else{
                        // Queda registrado para poder ver quién no acierta la clave.
                        registrarLoginFallido(
                          values.username,
                          user?.status?.message || "Usuario/contraseña incorrecta",
                          user?.status?.statusCode ?? null,
                        );
                        setError("Usuario/contraseña incorrecta!");
                      }
          }
          catch(error){
            //console.error("Error durante el login:",error);
            registrarLoginFallido(values.username, "Error en la autenticación", null);
            setError("Error en la autenticación. Intente nuevamente.");
          }
          finally{setSubmitting(false)}
      }}
      >
        {({isSubmitting})=>(
            <>
              <LoginContainer>
                <DataContainer>
                  <figure>
                    <img src="/imagenes/logo-iptel.png" alt="Logo" />
                  </figure>
                  <InputContainer>
                    <div className="input-group"> 
                      <Field name="username" type="text" id="username" required></Field>
                      <span htmlFor="username">Usuario</span>
                    </div>
                  </InputContainer>
                    <ErrorMessage name='username' component={ErrorStyled}></ErrorMessage>
                  <InputContainer>
                    <div className="input-group">   
                      <Field name="password" type='password' id="password" required></Field>
                      <span htmlFor="password">Contraseña</span>
                    </div>  
                  </InputContainer>
                    <ErrorMessage name='password' component={ErrorStyled}></ErrorMessage>
                  <ButtonForm disabled={isSubmitting} type={"submit"}> 
                    {
                      isSubmitting ? <Spinner/> : 'Iniciar sesión'
                    }
                  </ButtonForm>
                  {process.env.REACT_APP_VERSION && (
                    <VersionTag>v{process.env.REACT_APP_VERSION}</VersionTag>
                  )}
                </DataContainer>
              </LoginContainer>
                      {
                        error && (<Modal isOpen={true} onClose={() => setError(null)}>{error}</Modal>)
                      }
            </>
          )}

      </Formik>
      
    </>
  )
}

export default Login